'use client';

import { Ban } from 'lucide-react';

/**
 * Full-page message shown when a user's assignments are all suspended.
 * Directs them to contact OrderUp to have their account reinstated.
 */
export function SuspendedAccountMessage() {
  return (
    <div className="min-h-svh bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
          <Ban className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight mb-2">
          Account Suspended
        </h1>
        <p className="text-muted-foreground mb-6">
          Your account access has been temporarily suspended. Please reach out
          to OrderUp to have your account reinstated.
        </p>
        <a
          href="mailto:support@letsorderup.com"
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground shadow hover:bg-primary/90 transition-colors"
        >
          Contact OrderUp Support
        </a>
      </div>
    </div>
  );
}
